import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ActionResultDTO, ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { Configuration } from '../../conf/app.constants';

import { HelpService } from '../../components/common/help/help.service';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { tap, catchError, finalize, map } from 'rxjs/operators';
import * as lodash from 'lodash';

import { InterfaceSettings } from '../../api/contract-notice-dto';
import { forkJoin, ObservableInput } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { MasterDataDTO, PersonDTO } from '../../api/plyca-dtos';

import { formElementComponent } from '../../components/forms/formElement.component';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { SpendingProjectDTO } from '../../api/dipbad-dtos';
import { UserService } from '../../user.service';
import { DossierModelsService } from '../../dossiers/dossierModels/DossierModels.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';


export class SpendingProjectModel {

  dto: SpendingProjectDTO;
  ui: {
    indicatorType: number;
    indicator: string;
    totalBudgetAccountLines: number;
    totalCofinancingLines: number;
  }
}

@Component({
  selector: 'SpendingProject-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class SpendingProjectsComponent
  extends BaseFormComponent<SpendingProjectDTO, SpendingProjectModel>
  implements OnInit, OnDestroy, AfterContentInit {
  headerService: any;
  private identifier: string;
  public totalWork: number;
  public readonly = false;
  dossierId: string;



  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService,
    public dossierModelService: DossierModelsService,
    public userService: UserService,
    public dialogConfig: DynamicDialogConfig
  ) {
    super(elem);
    this.waitService.startWaiting();
    this.subscribe(this.activatedRoute.params
      .pipe(tap(params => (this.identifier = params['id'])))
    );
    this.waitService.cancelWaiting();
    // this.createDossierFromModel(this.model);
    if (this.identifier) {
      let expansionDossier = '?expand=expansionSet:detail';
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['readOnly']) {
        this.readonly = params['readOnly'];
      }
    });

  }

  ngAfterContentInit(): void {
    /*let profile = this.appConfig.getValue('spendingProject.edition.profiles');
    if (profile) {
      this.readonly = !this.userService.hasRoles(profile);
    }*/

  }

  getFormSettingURL(): string {
    return 'spendingProjects/spendingProjectInterfaceSettings.json';
  }

  close() { }

  dtoToModel(dto: SpendingProjectDTO): Observable<SpendingProjectModel> {
    let model = new SpendingProjectModel();
    model.dto = dto;

    if (this.task !== undefined) {
      if (this.task.work) {
        if (this.task.work.spendingProject === undefined) {
          this.uiService.showMessage(
            'Se ha producido un error en la carga de datos del contrato. ' +
            'Consulte con el administrador. ',
            'Aviso',
            'errorStyle'
          );
        }
        // if (model.dto.reloadProject === undefined || !model.dto.reloadProject) {
        model.dto = this.task.work.spendingProject;
      }
    }

    // TODO qué es esto? -> va a ser para cargar los indicadores correctamente
    // if (dto.projectIndicators != null && dto.projectIndicators.length > 0) {
    //   dto.projectIndicators.forEach(projectIndicator => {
    //     model.dto.projectIndicators
    //   });
    // }

    // Se hace transformación de MasterData a dos String porque así es en el mapping de servidor
    if (model != null && model.dto != null && model.dto.cofinancingLine != null && model.dto.cofinancingLine.length > 0) {
      model.dto.cofinancingLine.forEach(cofinancingLine => {

        if (cofinancingLine != null && cofinancingLine.entity !== undefined) {
          cofinancingLine.participant = new MasterDataDTO(cofinancingLine.entity, 'PROYECTO_PARTICIPES');
          cofinancingLine.participant.description = cofinancingLine.entityDescription;

        }
      });
    }


    let modelObs: Observable<SpendingProjectModel>;
    modelObs = of(model);

    if (model.ui === undefined) {
      model['ui'] = {
        indicatorType: 0,
        indicator: '',
        totalBudgetAccountLines: 0,
        totalCofinancingLines: 0
      }
    }

    this.calculateTotalWork(model);
    this.calculateTotalFinancing(model);

    return modelObs;
  }

  modelToDTO(model: SpendingProjectModel): SpendingProjectDTO {

    if (this.task) {
      this.task.work.spendingProject = model.dto;
      this.task.work.spendingProject.context = this.task.work.context;
    }

    // Se hace transformación de MasterData a dos String porque así es en el mapping de servidor
    if (model != null && model.dto != null && model.dto.cofinancingLine != null && model.dto.cofinancingLine.length > 0) {
      model.dto.cofinancingLine.forEach(cofinancingLine => {
        if (cofinancingLine != null && cofinancingLine.participant != null) {
          if (cofinancingLine.participant.identifier != null) {
            let i = cofinancingLine.participant.identifier.indexOf('<');
            if (i != null) {
              cofinancingLine.entity = cofinancingLine.participant.identifier.substring(0, i);
            } else {
              cofinancingLine.entity = cofinancingLine.participant.identifier;
            }
          }
          cofinancingLine.entityDescription = cofinancingLine.participant.description;
        }
      });
    }

    if (model != null && model.ui != null && model.ui.totalBudgetAccountLines != null) {
      model.dto.totalAmount = model.ui.totalBudgetAccountLines;
    }

    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Expediente de Gasto';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task && this.task.work) {
      identifier = this.task.work.spendingProject.identifier;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'spendingProjects/';
  }

  initHeaderActions() {

    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
        , (() => {
          this.validateSpendingProject();
        }));
      this.subscribe(this.headerActionsService
        .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
        , (
          () => {
            if (this.task !== undefined) {
              this.subscribe(this.saveIfValid());
            } else {
              this.subscribe(this.validate(false), result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                  this.uiService.showConfirmMessage({
                    message: 'Se han detectado errores que impiden la tramitación. ¿Desea guardar el expediente?',
                    header: 'Confirmacion',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {

                      console.log('Grabando expediente...');
                      this.subscribe(this.save(true), _model => {
                        if (_model) {
                          this.goToDossierInfo(_model);
                        } else {
                          this.goToDossierInfo(this.model.dto);
                        }
                      },
                        error => {
                          this.plycaErrorHandler.showServerError(error);
                        });

                    },
                    reject: () => {
                      this.waitService.cancelWaiting();
                      console.log('No hace nada...');
                    }

                  });
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.save(), _model => {
                    this.waitService.cancelWaiting();
                    if (_model) {
                      this.showConfirmMessage(_model);
                    } else {
                      this.showConfirmMessage(this.model.dto);
                    }

                  });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
              )

            }
          }));
    }

    this.headerActionsService.addDivider();
    this.addBack();
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.readonly = this.readonly;

    formConfig.functions.push({
      identifier: 'calculateTotalWork',
      fn: this.calculateTotalWork
    });

    formConfig.functions.push({
      identifier: 'calculateTotalFinancing',
      fn: this.calculateTotalFinancing
    });

    formConfig.functions.push({
      identifier: 'getIndicatorType',
      fn: this.getIndicatorType
    });

    formConfig.functions.push({
      identifier: 'cleanMeasure',
      fn: this.cleanMeasure
    });

    formConfig.functions.push({
      identifier: 'cleanCode',
      fn: this.cleanCode
    });

    return super.configureFormConfig(formConfig);
  }

  showConfirmMessage(_spendingProject: SpendingProjectDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.startProject(_spendingProject, this.getServiceURL())
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
          () => {
            this.goToDossierInfo(_spendingProject);
          },
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        this.goToDossierInfo(_spendingProject);
        console.log('Saliendo...');
      }
    });
  }

  goToDossierInfo(_spendingProject: SpendingProjectDTO) {
    this.router.navigate(['dossierInfo/' + _spendingProject.identifier], {
    });
  }



  validateSpendingProject() {

    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.uiService.showMessage(
          'Se ha validado correctamente.',
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {

        this.salir();
      }));
  }

  calculateTotalWork(model: any) {
    if (model != null && model.dto != null && model.dto.budgetAccountLines != null && model.dto.budgetAccountLines.length > 0) {
      model.ui.totalBudgetAccountLines = 0;
      model.dto.budgetAccountLines.forEach(budgetAccountLine => {
        if (budgetAccountLine != null && budgetAccountLine.budget != null && budgetAccountLine.budget.totalAmount != null) {
          model.ui.totalBudgetAccountLines += budgetAccountLine.budget.totalAmount;
        }
      });
    }
  }

  calculateTotalFinancing(model: any) {
    if (model != null && model.dto != null && model.dto.cofinancingLine != null && model.dto.cofinancingLine.length > 0) {
      if (this.model && this.model.dto) {
        model.ui.totalCofinancingLines = 0;
      }
      model.dto.cofinancingLine.forEach(cofinancingLine => {
        if (cofinancingLine != null && cofinancingLine.budgetAmount != null) {
          model.ui.totalCofinancingLines += cofinancingLine.budgetAmount;
        }
      });
    }
  }

  getIndicatorType(model: any) {
    if (model != null && model.projectIndicator != null && model.projectIndicator.indicatorId != null
      && model.projectIndicator.indicatorId.properties != null && model.projectIndicator.indicatorId.properties.TIPO_INDICADOR != null) {
      model.projectIndicator.indicatorType = model.projectIndicator.indicatorId.properties.TIPO_INDICADOR;
      model.indicatorId = model.projectIndicator.indicatorId.properties.ID_INDICADOR;
    }
  }

  cleanMeasure(model: any) {
    this.model.dto.measure = null;
  }

  cleanCode(model: any) {
    model.modificationCode = null;
  }
}
